import { IconWrapper } from '../runtime';
export default IconWrapper('actual-size', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4.75 5.74982V10.2498M11.25 5.74982V10.2498M3.25 14.2498H12.75C13.5784 14.2498 14.25 13.5782 14.25 12.7498V3.24976C14.25 2.42133 13.5784 1.74976 12.75 1.74976H3.25C2.42157 1.74976 1.75 2.42133 1.75 3.24976V12.7498C1.75 13.5782 2.42157 14.2498 3.25 14.2498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("circle", {
    "attrs": {
      "cx": "8.00232",
      "cy": "6.75208",
      "r": "0.752319",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("circle", {
    "attrs": {
      "cx": "8.00232",
      "cy": "9.24744",
      "r": "0.752319",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});